var moduleMap = {
	"./Module": () => {
		return Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-bootstrap_ng-bootstrap_ng-bootstrap_ng-bootstrap-w-d4b3c3"), __webpack_require__.e("default-webpack_sharing_consume_default_ngx-translate_core_ngx-translate_core"), __webpack_require__.e("default-webpack_sharing_consume_default_angularx-flatpickr_angularx-flatpickr-webpack_sharing-538245"), __webpack_require__.e("default-webpack_sharing_consume_default_sweetalert2_sweetalert2"), __webpack_require__.e("default-webpack_sharing_consume_default_lcms_shared_lazy-load-select_lcms_shared_lazy-load-select"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-apps_mfe-profile_src_app_remote-entry_entry_module_ts")]).then(() => (() => ((__webpack_require__(/*! apps/mfe-profile/src/app/remote-entry/entry.module.ts */ 31048)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});